import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Pill } from 'lucide-react';
import { validateForgotPassword } from '../../Services/loadOrder';
import ForgotMailModal from './ForgotMailModal';
import logo from '../../assets/images/logo-win-white.svg';
import '../../assets/css/login.css';
import toast, { Toaster } from 'react-hot-toast';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [pharmacyId, setPharmacyId] = useState('');
  const [userId, setUserId] = useState('');
  const [mailTo, setMailTo] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = () => {
    // Add your form submission logic here
    console.log("Submitting Forgot Password", { pharmacyId, userId });
    if (!pharmacyId || !userId) {
    toast.error('Please fill in all fields.');
      return;
    }
    validateForgotPassword(  userId, "", pharmacyId, "Validation")
      .then(response => {
        if (response) {
          setMailTo(response.data.MailTo);
          console.log("Response from validateForgotPassword:", response);
          toast.success(`Your Reset Password will be sent to ${response.data.MailTo}`);
          setIsModalOpen(true);

        } else {
          toast.error('Invalid Pharmacy ID or User ID.');
        }
      })
      .catch(error => {
        console.error('Error during password reset:', error);
        toast.error('Failed to reset password. Please try again later.');
      });

  };
  console.log("this is the mail to", mailTo);

  return (
    <div className="body-style">
      <Toaster position="top-right" />
      <div className="login-page">
        <header className="top-logo">
          <img src={logo} alt="Logo" />
        </header>

        <div className="login-container full-width">
          <div className="login-form" style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: '20px', fontWeight: '600' }}>Forgot Password</h1>

            {/* Pharmacy ID Field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div style={{ padding: '10px' }}>
                <Pill color="#ec088c"  />
              </div>
              <input
                type="text"
                placeholder="Enter PharmacyID"
                value={pharmacyId}
                onChange={(e) => setPharmacyId(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
            </div>

            {/* User ID Field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div style={{ padding: '10px' }}>
                <User color="#ec088c"  />
              </div>
              <input
                type="text"
                placeholder="Enter User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              style={{
                marginTop: '10px',
                padding: '8px 20px',
                backgroundColor: '#ec088c',
                border: '1px solid #ccc',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <ForgotMailModal
            open={isModalOpen}
           onClose={() => {
            setIsModalOpen(false);
          // Navigate only after modal is closed
          }}
            pharmacyID = {pharmacyId}
            userID = {userId}
            mailTo={mailTo}
          />
    </div>
  );
};

export default ForgotPassword;
